import axios, { AxiosResponse } from "axios";
import moment from "moment";

export const productsService = {
  getProducts: (agentCode: string, from: Date): Promise<AxiosResponse<any>> => {
    return axios.get<any>(
      `/products/${agentCode}?from=${moment(from).format("YYYY-MM-DD")}`,
      {
        headers: { "content-type": "application/json" }
      }
    );
  }
};
